<template>
	<div>
		<div class="panel panel-bggray panel-cards" style="padding-bottom: 40px;">
			<div class="container">
				<div class="cards">
					<ul class="cards-tabs">
							<li id="" v-for="(item,index) in cardList" :key="index">
								<router-link :to="{path:'/shop?cateid='+item.cate_id}">
									<i class="iconfont" :class="item.icons"></i>
									<span>{{item.name}}</span>
<!-- 									<span class="cover">
										<img :src="item.img" />
									</span> -->
								</router-link>
							</li>

					</ul>
					<div class="cards-content">
						<div class="cards-item">
							<div class="cards-group owl-carousel clearfix owl-theme">
								<div class="owl-wrapper-outer">
									<div class="owl-wrapper">
										<el-carousel trigger="click" :autoplay="false" indicator-position="outside" height="230px">
											<el-carousel-item v-for="item1 in carousel" :key="item1">
												<div class="owl-item" v-for="(item,index) in hotList" v-if="item1 === 1?index<6:index>6" :key="index" style="width: 230px;">
													<div class="item">
														<div class="cards-cover">
															<a>
																<img :src="item.image?item.image.file_path:''" />
															</a>
															<h5 class="title">
																<a>{{item.goods_name}}</a>
															</h5>
															<h6 class="discount"></h6>
															<div class="actions">
																<router-link :to="{path:'/shop?cateid='+item.cate_id+'&goodid='+item.id}">


																	<span class="btn btn-default">
																		我要卖卡
																	</span>
																</router-link>
															</div>
														</div>
													</div>
												</div>
											</el-carousel-item>
										</el-carousel>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:"hotCommon",
		data(){
			return{
				hotList:[],
				carousel:2,
				imgList:[require('../../static/images/home/phone.jpg'),require('../../static/images/home/oil.jpg'),require('../../static/images/home/game.jpg'),require('../../static/images/home/film.jpg'),
				require('../../static/images/home/shop.jpg'),require('../../static/images/home/trip.jpg'),require('../../static/images/home/cate.jpg'),require('../../static/images/home/movie.jpg')
				],
				iconList:[
					'text-red icon-shoujichongzhitianchong','text-pink icon-jiayouzhan-01','text-purple icon-iconfontyouxihudong','text-blue icon-gouwuche',
					'text-orange icon-wentichaoshi','text-green icon-yangshi_icon_tongyong_travel_card','text-choc  icon-wodemeishi0101','text-red icon-yingyinjiaocai'
				],
				cardList:[]
			}
		},
		created(){
			this.hot()
			this.getCardList()
		},
		props:{
		},
		methods:{
			// 卡券分类
			getCardList(){
				let token = localStorage.getItem('token')
				this.$api.list({
					token:token
				}).then(res => {
					if(res.code === 1){
						let list = res.data
						for(let i=0;i<list.length;i++){
							if(list[i].name === "积分兑"){
								continue
							}
							list[i].img = this.imgList[i]
							list[i].icons = this.iconList[i]
							this.cardList.push(list[i])
						}
					}
				})
			},
			hot() {
				let token = localStorage.getItem('token')
					this.$api.apiAddress({
							token:token
					}).then(res => {
							if(res.code === 1){
								this.hotList = res.data
							}
							this.carousel = Math.ceil(this.hotList.length/6)
					})
			},
		}
	}
</script>

<style>
	.cover img{
		width: 120px;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/hot_topick.vue